import { IViewModel } from '../../interfaces/view-model.interface';

export class FolderRoleMember implements IViewModel {
    public id: number;

    folderId: number;
    folderRolePermissionExpressionId: number;

    public memberType: string;
    public member: string;
    public memberId: string; // When returning this object as a view model, this gets set to the actual MAX ID or MAX group code,
                             // whereas property 'Member' gets set to the display name for the user or group.

    public addToAllDescendants: boolean = false;
    public addToAllSharingTheRolePermission: boolean = false;

    public constructor(folderId: number, folderRolePermissionExpressionId: number, memberType: string, member: string, memberId: string) {
        this.folderId = folderId;
        this.folderRolePermissionExpressionId = folderRolePermissionExpressionId;
        this.memberType = memberType;
        this.member = member;
        this.memberId = memberId;
    }
}
